import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, config, } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  apiURL: string = '';
  constructor(private http: HttpClient, @Inject('api_url') private apiUrl: string) { }

  get<T>(path: string, params: HttpParams = new HttpParams(), applyBaseApiUrl: boolean = true): Observable<T> {
    return this.http.get<T>(this.getUrl(path, applyBaseApiUrl), { params })
      .pipe(catchError(this.formatErrors));
  }

  getResponse(path: string, params: HttpParams = new HttpParams(), applyBaseApiUrl: boolean = true): Observable<any> {
    return this.http.get(this.getUrl(path, applyBaseApiUrl), { params, observe: 'response' })
      .pipe(catchError(this.formatErrors));
  }

  getText(path: string, params: HttpParams = new HttpParams(), applyBaseApiUrl: boolean = true): Observable<string> {
    return this.http.get(this.getUrl(path, applyBaseApiUrl), { params, responseType: 'text' })
      .pipe(catchError(this.formatErrors));
  }

  getBlob(path: string, responsetype: 'blob', applyBaseApiUrl: boolean = true): Observable<any> {
    return this.http.get(path, { observe: 'response' as 'body', responseType: responsetype })
      .pipe(catchError(this.formatErrors));
  }

  put<T>(path: string, body = {}, applyBaseApiUrl: boolean = true): Observable<T> {
    return this.http.put<T>(this.getUrl(path, applyBaseApiUrl),
      body
    ).pipe(catchError(this.formatErrors));
  }

post<T>(path: string, body = {}, applyBaseApiUrl = true, headers?: HttpHeaders): Observable<T> {
  return this.http.post<T>(this.getUrl(path, applyBaseApiUrl), body, {
    ...(headers ? { headers } : {})
  });
}

  delete<T>(path: string, applyBaseApiUrl: boolean = true): Observable<T> {
    return this.http.delete<T>(
      this.getUrl(path, applyBaseApiUrl)
    ).pipe(catchError(this.formatErrors));
  }

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  getUrl = (path: string, applyBaseApiUrl: boolean): string => {
    return applyBaseApiUrl === true ? `${this.apiUrl}${path}` : `${path}`;
  }
}
